import { serialize } from "../formUtils.js"

class Filters {
  constructor() {
    this.baseUrl = window.location.pathname

    this.initComponents()
    this.bindEvents()
    this.showSummaries()
  }

  initComponents() {
    this.form = document.querySelector("form[name=blog__filters]")
    this.filters = document.querySelectorAll(".blog__filter")
    this.container = document.querySelector(".blog__article-summaries")
    this.summariesTitle = document.querySelector(".blog__article-summaries-title")
    this.summaries = document.querySelectorAll(".article-summary")
    this.spinner = document.querySelector(".gwrc-loading")
  }

  bindEvents() {
    // Bind standard browser events out here
    this.filters.forEach(filter => {
      filter.addEventListener("selectr.init", () => {
        // Bind custom selectr events once they have initialised
        filter.selectr.on("selectr.change", () => {
          this.getArticles()
        })
      })
    })
  }

  getArticles() {
    // selected filters
    const queryParams = serialize(this.form)

    // update view
    this.spinner.style.display = "block"
    this.container.innerHTML = null
    if (queryParams) {
      this.summariesTitle.style.display = "none"
    } else {
      this.summariesTitle.style.display = "block"
    }

    // send request
    var xhr = new XMLHttpRequest()
    xhr.open("GET", this.baseUrl + "?" + queryParams)
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
    xhr.onload = () => this.replaceArticles(xhr.status, xhr.response)
    xhr.send()
  }

  replaceArticles(status, articleHtml) {
    this.spinner.style.display = "none"

    this.container.innerHTML = articleHtml
    this.summaries = document.querySelectorAll(".article-summary")
    this.showSummaries()
  }

  showSummaries() {
    this.summaries.forEach((summary, index) => {
      let delay = index * 150
      setTimeout(this.fadeIn(summary), delay)
    })
  }

  fadeIn(summary) {
    return function() {
      summary.style.opacity = 1
    }
  }
}

export default function init() {
  if (document.querySelector(".NewsHub")) {
    new Filters()
  }
}
